export const AUTH_ENDPOINTS = {
    LOGIN: "/login",
    LOGOUT: "/logout",
    ME: "/me",
} as const;
